import { ReactNode } from 'react';
import { IActivityLog } from '@publishing-engine/domain/models';
import { createActivityLogHandlers } from './activityLogHandlers';

type IActivityLogText = {
  title: ReactNode;
  content?: ReactNode;
};

export const generateActivityCopyText = (
  activityLog: IActivityLog,
  fieldLabelMap?: Record<string, string>
): IActivityLogText => {
  const handlers = createActivityLogHandlers(fieldLabelMap);
  const handler =
    handlers[activityLog.type as keyof typeof handlers];

  if (handler) {
    return handler(activityLog);
  }

  return { title: activityLog.type };
};
